module.exports = {
  setPayments: (state, array) => {
    state.payments = array
  },
  setOffers: (state, array) => {
    state.offers = array
  },
  setRewards: (state, array) => {
    state.rewards = array
  },
  setMarketplace: (state, array) => {
    state.marketplace = array
  },
  setFavLocs: (state, array) => {
    state.favLocs = array
  },
  setFavOrders: (state, array) => {
    state.favOrders = array
  },
  setAddresses: (state, array) => {
    state.addresses = array
  },
  setSignUpOptions: (state, object) => {
    state.signUpOptions = object
  },
  setChallenges: (state, array) => {
    state.challenges = array
  },
  setRedeemables: (state, array) => {
    state.redeemables = array
  },
  setBadges: (state, array) => {
    state.badges = array
  },
}